import { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions"


import {
   MapContainer,
   TileLayer,
   useMap,
   Marker,
   Popup,
   Tooltip,
   SVGOverlay,
   CircleMarker,
   Polygon,
} from "react-leaflet";
import "./styles/karte.css";
import { MapLibreTileLayer } from "./MapLibreTileLayer";
import L from "leaflet";
import markerA from "./img/marker.webp";

import markerPin from "./img/pinMarker.webp";
import markerCircle from "./img/roundmarker.png";
import GetGeoCoords from "./GetGeoCoords";

export default function Karte({
   userObjects,
   terminInfos,
   availableUsers,
   showAllUsers,
   calenderday,
   showAlleTage,
   setSelectedTermin,
   selectedTermin,
   terminArten,
   centerPin,
   suedPolygon,
}) {
   const iconA = new L.Icon({
      iconUrl: markerA,
      iconRetinaUrl: markerA,
      popupAnchor: [-0, -0],
      iconSize: [32, 45],
      iconAnchor:[16, 45],
      className: "custommarker",
   });

   const [map, setMap] = useState(null);
   const iconB = new L.Icon({
      iconUrl: markerCircle,
      popupAnchor: [-0, -0],
      iconSize: [16, 16],
   });

   const iconPin = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
   });

   const [searchCoords, setSearchCoords] = useState();

   useEffect(() => {
      if (map && searchCoords) {
         map.setView([searchCoords.lat, searchCoords.lon], 14);
      }
   }, [map, searchCoords]);

   useEffect(() => {
      if (map && centerPin&&centerPin.breitengrad) {
         console.log([parseFloat(centerPin.breitengrad), parseFloat(centerPin.laengengrad)]);

         map.setView([parseFloat(centerPin.breitengrad), parseFloat(centerPin.laengengrad)], 14);
      }
   }, [map, centerPin]);

   const center = [48.069127679996505, 9.78794715586747];
   const standorte = {
      biberach: [48.09982945986149, 9.788116225682414],
      ulm: [48.39759756595353, 9.991208742270867],
      weingarten: [47.80724916089593, 9.636884784540829],
      ravensburg: [47.7813069817177, 9.613369915116529],
   };
   return (
      <>
         <div className="mapframe">
            <div style={{ position: "absolute", zIndex: 10, margin: "20px" }}>
               <GetGeoCoords searchCoords={searchCoords} setSearchCoords={setSearchCoords} />
            </div>
            <MapContainer
               center={center ? center : [47.807276048680215, 9.63688394923563]}
               zoom={10.1}
               zoomSnap={0.1}
               wheelPxPerZoomLevel={160}
               zoomControl={false}
               ref={setMap}
               scrollWheelZoom={true} /*  attributionControl={false} */
            >
               {/* <MapLibreTileLayer
                  url="https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json"
               /> */}
               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               {Object.keys(standorte).map((item) => (
                  <Marker icon={iconA} position={standorte[item]}></Marker>
               ))}

               {availableUsers &&
                  terminInfos
                     .filter((item) => showAllUsers?true:availableUsers[item.benutzer[0].id])
                     .map((item, index) => {
                        let longlat = [parseFloat(item.breitengrad?item.breitengrad:0), parseFloat(item.laengengrad?item.laengengrad:0)];
                        const daysLeft =
                           "custommarker-" + parseInt(Math.round((item.datum - new Date()) / (1000 * 24 * 3600)));
                        //   console.log(daysLeft);

                        let myPathOptions = { color: "black", weight: 0, fillOpacity: 0.01 };
                        let myStyle = {
                           padding: "4px 8px",
                           borderRadius: "16px",
                           backgroundColor: userObjects[item.benutzer[0].id]
                              ? userObjects[item.benutzer[0].id].color
                              : "#000",
                           boxShadow: selectedTermin == item.terminId ? "0 0 20px 20px #f00" : "",
                        };

                        let showMarker = true;
                        if (!showAlleTage) {
                           myStyle["opacity"] =
                              item.datum.toLocaleDateString() === calenderday.toLocaleDateString() ? 1 : 0.1;
                           showMarker = item.datum.toLocaleDateString() === calenderday.toLocaleDateString();
                        }

                        return (
                           <>
                              {showMarker && (
                                 <CircleMarker center={longlat} radius={20} pathOptions={myPathOptions}>
                                    <Tooltip
                                       direction="center"
                                       offset={[0, 0]}
                                       opacity={1}
                                       permanent
                                       zIndex={index == 1 ? 1000 : 0}
                                    >
                                       <div
                                          style={{
                                             ...myStyle,
                                          }}
                                       >
                                          {new Intl.DateTimeFormat("de-DE", { weekday: "short" }).format(item.datum)}{" "}
                                          {item.datum.getDate()}. <br />{" "}
                                          {userObjects && <span>{userObjects[item.benutzer[0].id].Kuerzel}</span>}
                                       </div>
                                    </Tooltip>
                                    <Popup offset={[0, -20]}>
                                       <div>
                                          <h5>{item.datum.toLocaleString()}</h5>
                                          <strong>{item.type.label}</strong>
                                          <br /> {item.benutzer[0].userName}
                                          <br />
                                          <br />
                                          {item.strasse} {item.hausnummer} <br /> {item.plz} {item.ort} <br />
                                          <br />
                                          <a
                                             className="btn btn-outline-primary"
                                             href={"/datenblatt?estateid=" + item.estateId}
                                             target="_blank"
                                          >
                                             {item.objektnr_extern} ↗
                                          </a>
                                       </div>
                                    </Popup>
                                 </CircleMarker>
                              )}
                           </>
                        );
                     })}

               {suedPolygon && <Polygon pathOptions={{weight: 1, color: "#909", fillOpacity: 0.1 }} positions={suedPolygon}></Polygon>}
               {centerPin&&centerPin.breitengrad && (
                  <Marker icon={iconPin} position={[centerPin.breitengrad, centerPin.laengengrad]}></Marker>
               )}
               {searchCoords && <Marker icon={iconB} position={[searchCoords.lat, searchCoords.lon]}></Marker>}
            </MapContainer>
         </div>
      </>
   );
}

